

declare global {
  interface Window {
    smartCaptcha?: any;
  }
}

/**
 * @module /google-recaptcha/loadRecaptchaScript
 * @description
 * Вспомогательный модуль для подгрузки капчи
 */
export default (callbackName: string, callback: Function) => {
  loader(`https://smartcaptcha.yandexcloud.net/captcha.js?render=onload&onload=${callbackName}`, callback);

  function loader(src: string, callback: Function) {
    let testDouble = document.querySelector('script[src^="https://smartcaptcha.yandexcloud.net/captcha.js"]');

    if (!testDouble && !window.smartCaptcha) {
      const script = document.createElement('script');
      script.setAttribute('src', src);
      document.body.insertAdjacentElement('afterend', script);
    } else {
      callback();
    }
  }
}
